import myPic from './assets/profile1.jpeg';
export const BASIC_CONTENT = {
  name: 'Raj Narayanan',
  email: 'rajaofficial1138@gmail.com',
  age: 25,
  from: 'TamilNadu, India',
  role: 'Frontend Developer',
  profilePic: myPic,
  number: 7010529783,
  description: 'Experienced web developer with 3 years of expertise in building responsive and interactive websites using React, Redux.Detail - oriented web developer with a proven track record of delivering high- quality web applications',
  studies: [
    {
      pursued_from: '2016 - 2020',
      degree: "Electrical and Electronics Communication Engineering",
      instution: 'Mepoc Schlenk Engineering Colleg, Sivakasi, TamilNadu',
      grade: 8.65,
    }, 
    {
      pursued_from: '2015 - 2016',
      degree: "Higher Secondary",
      instution: 'Sri Jeyendra Silver Jubliee Matric School, Tirunelveli, TamilNadu',
      grade: '94.8%',
    },
    {
      pursued_from: '2013 - 2014',
      degree: "SSLC",
      instution: 'St.Jhons Higher Secondary School, Tirunelveli, TamilNadu',
      grade: '97%',
    },
  ],
  work_experience: [
    {
      year: "2021 - 2024",
      company: "Tekion India Private Limited",
      location: 'Chennai,TamilNadu',
      experience: 3,
    },
  ],
  skills: [
    {
      title: 'HtML/CSS',
      percentage: 80,
    },
    {
      title: 'JS',
      percentage: 85,
    },
    {
      title: 'React JS',
      percentage: 80,
    },
    {
      title: 'Redux',
      percentage: 70,
    },

  ]
}

export const HOME_TEXT_TODISPLAY = [`I'm ${BASIC_CONTENT.name}.`, `I'm a ${BASIC_CONTENT.role}.`];